<template>
  <div class="home">
    <main class="home-main">
      <div class="mode-card" @click="goTo('dailyWord')">
        <div class="mode-left">
          <div class="check-box" :class="{ checked: dailyWordDone }">
            <span v-if="dailyWordDone">✔</span>
          </div>
          <span class="mode-label">MOT DU JOUR</span>
        </div>
        <div class="mode-right" v-if="dailyWordStreak > 0">
          <div class="star">
            <span>{{ dailyWordStreak }}</span>
          </div>
        </div>
      </div>

      <div class="mode-card" @click="goTo('dailySuite')">
        <div class="mode-left">
          <div class="check-box" :class="{ checked: dailySuiteDone }">
            <span v-if="dailySuiteDone">✔</span>
          </div>
          <span class="mode-label">SUITE DU JOUR</span>
        </div>
        <div class="mode-right" v-if="dailySuiteStreak > 0">
          <div class="star">
            <span>{{ dailySuiteStreak }}</span>
          </div>
        </div>
      </div>

      <div class="mode-card single" @click="goTo('infinite')">
        <div class="mode-left">
          <div class="icon-user">👤</div>
          <span class="mode-label">INFINI</span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getModeState } from "../utils/storage";
import { getCurrentDayIndex } from "../utils/dailyWords";
import TusmoLogo from "./TusmoLogo.vue";

export default {
  name: "HomeScreen",
  components: {
    TusmoLogo,
  },
  data() {
    const day = getCurrentDayIndex();
    const dw = getModeState("dailyWord");
    const ds = getModeState("dailySuite");
    return {
      todayIndex: day,
      dailyWordState: dw,
      dailySuiteState: ds,
    };
  },
  computed: {
    dailyWordDone() {
      return this.dailyWordState.lastSolvedDay === this.todayIndex;
    },
    dailySuiteDone() {
      return this.dailySuiteState.lastSolvedDay === this.todayIndex;
    },
    dailyWordStreak() {
      return this.dailyWordState.streak || 0;
    },
    dailySuiteStreak() {
      return this.dailySuiteState.streak || 0;
    },
  },
  methods: {
    goTo(mode) {
      this.$router.push({ name: "game", params: { mode } });
    },
  },
};
</script>

<style scoped>
.home {
  /* min-height: 100vh; */
  color: var(--text-main);
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 50px;
  margin-top: 60px;
}

.logo-bar {
  padding-top: 24px;
  padding-bottom: 40px;
}

.logo-tusmo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-square {
  background: #d63f35;
  color: #ffffff;
  font-weight: 800;
  font-size: 40px;
  padding: 10px 22px;
  border-radius: 8px;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.3);
}

.logo-circle {
  background: #f4c443;
  color: #ffffff;
  font-weight: 800;
  font-size: 40px;
  padding: 10px 22px;
  border-radius: 999px;
  margin: 0 6px;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.3);
}

.home-main {
  width: 100%;
  max-width: 416px;
  padding: 0 16px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  margin-top: 16px;
}

.mode-card {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background: var(--card-bg);
  color: #154153;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 8px 0 var(--card-shadow);
  cursor: pointer;
  height: 85px;
}

.mode-card.single {
  justify-content: flex-start;
}

.mode-left {
  display: flex;
  align-items: center;
  padding: 16px 20px;
}

.mode-label {
  font-weight: 700;
  letter-spacing: 0.08em;
}

.check-box {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 3px solid #154153;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 18px;
}

.check-box.checked {
  background: #154153;
  color: #ffffff;
}

.mode-right {
  display: flex;
  align-items: stretch;
}

.star {
  background: var(--card-bg);
  border-left: 1px solid #dddddd;
  border-radius: 0 14px 14px 0;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #007c8c;
}

.icon-user {
  margin-right: 18px;
  font-size: 20px;
}

/* Responsive */
@media (max-width: 480px) {
  .logo-square,
  .logo-circle {
    font-size: 30px;
    padding: 8px 16px;
  }

  .mode-card {
    margin-bottom: 12px;
  }

  .mode-left {
    padding: 12px 14px;
  }

  .check-box {
    margin-right: 14px;
  }
}
</style>
